import { DateUtils, logger, RemoteConfigService } from '@web_opxp/features';
import ENV from '../base/env';
import { MedUrl } from './constants';
import { IExperimentShowValue, IOnboardingFlowConfig } from './types';

export const DEFAULT_ONBOARDING_FLOW: IOnboardingFlowConfig = {
  variant: 'fallback',
  med_subscribe_banner: false, // banner disabled
  med_subscribe_banner_times: 5,
  med_subscribe_banner_delay: 48 * 60 * 60, // 48 Hrs in seconds
  med_subscribe_followup: false, // bridge screen disabled
  med_subscribe_followup_times: 3,
  med_subscribe_followup_delay: 48 * 60 * 60, // 48 Hrs in seconds
};

let ObFlowConfig: IOnboardingFlowConfig;
export function getObFlowConfig() {
  if (!ObFlowConfig) {
    ObFlowConfig =
      RemoteConfigService.getObjectConfigValue<IOnboardingFlowConfig>(ENV.RemoteConfigOnboardingFlow) ||
      DEFAULT_ONBOARDING_FLOW;
  }
  return ObFlowConfig;
}

export function redirectToMed() {
  window.open(MedUrl, '_blank');
}

export function isShownEnoughTimes(value: IExperimentShowValue | null, timesLimit: number | undefined) {
  return !!timesLimit && !!value && value.times >= timesLimit;
}

export function isShownRecently(value: IExperimentShowValue | null, delay: number | undefined) {
  if (!delay || !value) {
    return false;
  }
  const now = DateUtils.getUnixTimestamp();
  return now - value.shownAt < delay;
}

export function shouldShow(propName: string, times?: number, delay?: number) {
  const stateStr = localStorage.getItem(propName);
  const state: IExperimentShowValue | null = JSON.parse(stateStr ?? 'null');
  const isEnough = isShownEnoughTimes(state, times);
  const isRecently = isShownRecently(state, delay);
  logger(['shouldShow', propName, isEnough, isRecently]);
  return !isEnough && !isRecently;
}

export function triggerShow(propName: string) {
  const stateStr = localStorage.getItem(propName);
  const state: IExperimentShowValue | null = JSON.parse(stateStr ?? 'null');
  const newState: IExperimentShowValue = {
    shownAt: DateUtils.getUnixTimestamp(),
    times: state ? state.times + 1 : 1,
  };
  localStorage.setItem(propName, JSON.stringify(newState));
}
